// utils.js
import { getCode, getName } from "country-list";

function normalDate(d) {
  if (!d) return "";
  var date = new Date(d);
  if (isNaN(date)) return "";
  return (
    date.getDate() +
    " " +
    date.toLocaleString("default", { month: "long" }) +
    " " +
    date.getFullYear()
  );
}

export default normalDate;

export const getCountryCodeByName = (countryName) => {
  return getCode(countryName) || "";
};

// `country-list` returns the ISO *official* names, several of which are far
// too long for a table cell ("United Kingdom of Great Britain and Northern
// Ireland"). Override the worst offenders with the names people actually use.
const SHORT_NAMES = {
  GB: "United Kingdom",
  US: "United States",
  AE: "United Arab Emirates",
  RU: "Russia",
  KR: "South Korea",
  KP: "North Korea",
  IR: "Iran",
  SY: "Syria",
  VE: "Venezuela",
  BO: "Bolivia",
  TZ: "Tanzania",
  VN: "Vietnam",
  LA: "Laos",
  MD: "Moldova",
  MK: "North Macedonia",
  BN: "Brunei",
  PS: "Palestine",
  TW: "Taiwan",
  CZ: "Czechia",
  NL: "Netherlands",
};

// ISO alpha-2 -> display name. Player.nationality and Club.country are both
// stored as codes, so every country rendered in the UI comes through here.
export const getCountryName = (code) => {
  if (!code) return "";
  const key = code.toUpperCase();
  return SHORT_NAMES[key] || getName(key) || code;
};

// "11 – 14 June 2026", collapsing the month and year when they are shared.
export const formatDateRange = (start, end) => {
  if (!start) return "";
  const s = new Date(start);
  if (isNaN(s)) return "";
  const e = end ? new Date(end) : null;

  const month = (d) => d.toLocaleString("default", { month: "long" });
  if (!e || isNaN(e) || s.toDateString() === e.toDateString()) {
    return `${s.getDate()} ${month(s)} ${s.getFullYear()}`;
  }
  if (s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth()) {
    return `${s.getDate()} – ${e.getDate()} ${month(e)} ${e.getFullYear()}`;
  }
  if (s.getFullYear() === e.getFullYear()) {
    return `${s.getDate()} ${month(s)} – ${e.getDate()} ${month(e)} ${e.getFullYear()}`;
  }
  return `${normalDate(s)} – ${normalDate(e)}`;
};

// Thousands separators for points and counts. Rankings are full of numbers and
// they must read consistently.
export const formatNumber = (n) =>
  typeof n === "number" && !isNaN(n) ? n.toLocaleString("en-US") : "0";

// Age from a date of birth, or null when the DOB is not public.
export const getAge = (dob) => {
  if (!dob) return null;
  const d = new Date(dob);
  if (isNaN(d)) return null;
  const diff = Date.now() - d.getTime();
  const age = Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
  return age > 0 && age < 120 ? age : null;
};
